import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0da0d92d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "merchant-day"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 活动说明 ");
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 分享 ");
const _hoisted_4 = {
  class: "bg-wrapper"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "money-img"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "date-range"
};
const _hoisted_9 = {
  class: "list-wrapper"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "index-txt"
};
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "score-info"
};
const _hoisted_14 = {
  class: "des"
};
const _hoisted_15 = {
  class: "score-info"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "挖矿分", -1));
const _hoisted_17 = {
  key: 2,
  class: "me-first-info"
};
const _hoisted_18 = {
  key: 1,
  class: "index-txt"
};
const _hoisted_19 = {
  class: "info"
};
const _hoisted_20 = {
  class: "score-info"
};
const _hoisted_21 = {
  class: "des"
};
const _hoisted_22 = {
  class: "score-info"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "挖矿分", -1));
import { onMounted, computed, reactive, ref, onBeforeMount, onUnmounted } from "vue";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
// import minerTask from "../../components/activity/miner_task.vue";
import env from "md-base-tools/env";
import redirect from '@/service/redirect';
import { getMinerRank } from "@/api";
import domain from "@/service/domain";
import ShareBox from "@@/common/ShareBox.vue";
import lowerdev from '@/service/lowerdev';
import router from '@/router';
import { GoBack, mdToast, postWXMessage } from "../../utils/tools";
export default {
  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const share_1x1 = "https://p6.moimg.net/mdwxapp/miner/wx_share_icon.png?x-oss-process=image/resize,w_350,h_350,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_5x4 = "https://p6.moimg.net/mdwxapp/miner/mina_share_icon.png?x-oss-process=image/resize,w_600,h_480,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const shareInfo = {
      active_title: "",
      img: share_1x1,
      mina_app_name: "gh_7210ac3f1f08",
      // gh_5638b10d3ccb
      mina_share_img: share_5x4,
      mina_share_path: `pages/webviewPages/content/content?url=${domain.wap}/mdactivity/fastsell/miner/rank`,
      msg_des: "快跟我一起 投身\"挖矿\" 大业，获取海量资源！",
      qq_des: "",
      qq_share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      qq_title: "快跟我一起 投身\"挖矿\" 大业，获取海量资源！",
      qr_img: share_1x1,
      qzone_share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      sharelink_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      small_code: "",
      weibo_des: "快跟我一起 投身\"挖矿\" 大业，获取海量资源！" + `${domain.wap}/mdactivity/fastsell/miner/rank` + '（分享自@摩点）',
      weibo_share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      weibo_title: "",
      weixin_share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      wxTimeline_share_url: `${domain.wap}/mdactivity/fastsell/miner/rank`,
      wx_des: "",
      wx_title: "快跟我一起 投身\"挖矿\" 大业，获取海量资源！"
    };

    // 调用 mutation
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: shareInfo
      }); // 调用 changeShareStatus mutation
      store.commit('changeShareStatus', {
        obj: 'showShare'
      }); // 调用 changeShareStatus mutation
    };

    // const ifLogin = computed(() => store.state.user.ifLogin)
    const userId = computed(() => store.state.user.userId);
    const state = reactive({
      is_ip: false,
      statusBarH: 10,
      page: 1,
      page_size: 20,
      rankList: [],
      refreshing: false,
      is_next: false,
      loading: false,
      request_finished: false,
      user_rank_info: {},
      date_range: '',
      from: ''
    });
    onBeforeMount(() => {
      if (env.isWxApp()) {
        lowerdev.dynamicScript("https://res.wx.qq.com/open/js/jweixin-1.3.2.js");
      }
    });
    onMounted(() => {
      state.is_ip = route.query.is_ip == 1 ? true : false;
      state.from = route.query.from;

      // Add more detailed logging to debug the route parameters
      console.log('Route query parameters:', route.query);
      console.log('from parameter value:', state.from);
      console.log('Complete route object:', route);
      configMinaShre();
      onRefresh();

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
          }
        });
      }

      // 添加滚动事件监听
      window.addEventListener('scroll', handleScroll);

      // Initial check
      handleScroll();
    });
    onUnmounted(() => {
      // 移除滚动事件监听
      window.removeEventListener('scroll', handleScroll);
    });
    function configMinaShre() {
      // 小程序页面加载完毕才会接受分享配置
      setTimeout(() => {
        postWXMessage({
          title: '快跟我一起 投身"挖矿" 大业，获取海量资源！',
          imageUrl: share_5x4,
          url: `${domain.wap}/mdactivity/fastsell/miner/rank`
        });
      }, 1000);
    }

    // Replace with simplified reactive variables for scroll control
    const isScrolled = ref(false);
    const scrollY = ref(0);
    const bgImageHeight = 250; // Height threshold for color change

    // 监听滚动事件 - simplified to only handle color change
    function handleScroll() {
      // Get current scroll position
      scrollY.value = window.scrollY;

      // Determine if we should change header color based on scroll position
      isScrolled.value = scrollY.value >= bgImageHeight;

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: isScrolled.value ? '0' : '1'
          }
        });
      }
    }

    // 下拉刷新
    async function onRefresh() {
      state.page = 1;
      await requestRankList();
      //完成刷新
    }

    // 上拉加载
    async function onLoadMore() {
      await requestRankList();
    }
    async function requestRankList() {
      const {
        status,
        data,
        message
      } = await getMinerRank({
        page: state.page,
        page_size: state.page_size
      });
      state.loading = false;
      state.refreshing = false;
      state.request_finished = true;
      if (status == 0) {
        if (state.page == 1) {
          state.rankList.splice(0, state.rankList.length);

          // 用户排名信息
          if (data.login_user_rank && data.login_user_rank.user_id) {
            state.user_rank_info = data.login_user_rank;
          }

          // 当前排名周范围
          if (data.date_range) {
            state.date_range = data.date_range;
          }
        }
        if (data.list && data.list.length > 0) {
          state.rankList.push(...data.list);
          state.page++;
          state.is_next = data.is_next;
        }
      } else {
        mdToast(message || '获取数据失败');
      }
    }
    function statusNameStyle(medal_level) {
      // 1菜鸟 2资深 3精英 4达人 5传奇
      let style = {
        'color': '#FFFFFF',
        'background': '#F2F2F2'
      };
      switch (medal_level) {
        case 5:
          style = {
            'color': '#FFFFFF',
            'background': '#FFD769'
          };
          break;
        case 2:
          style = {
            'color': '#FFFFFF',
            'background': '#C78CFF'
          };
          break;
        case 3:
          style = {
            'color': '#FFFFFF',
            'background': '#00C4A1'
          };
          break;
        case 4:
          style = {
            'color': '#FFFFFF',
            'background': '#69C8FF'
          };
          break;
        case 1:
          style = {
            'color': '#333333',
            'background': '#F2F2F2'
          };
          break;
        default:
          break;
      }
      return style;
    }

    // 离开页面
    function handleGoBack() {
      GoBack();
    }
    function handleHostoryAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/mdactivity/miner/history_rank`,
        webFun: () => {
          router.push({
            path: `/mdactivity/miner/history_rank`
          });
        }
      });
    }

    // 任务规则
    function handleTaskRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/mdactivity/miner_rule`,
        webFun: () => {
          router.push({
            path: `/mdactivity/miner_rule`
          });
        }
      });
    }

    // 分享
    function handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(shareInfo))
        });
      } else {
        triggerChangeShareStatus();
      }
    }

    // 展示赚挖矿分弹窗

    const goToMinerTaskCenter = () => {
      // 如果未登录，跳转登录页
      if (!userId.value) {
        redirect.to('login');
      }
      if (state.from == 'task') {
        GoBack();
      } else {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "openController",
          functionParams: `${domain.wap}/score/task/index`,
          webFun: () => {
            if (env.isMobile()) {
              router.push({
                path: `/score/task/index`
              });
            } else {
              window.location.href = 'https://member.modian.com/operate_manage/task';
            }
          }
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_Error = _resolveComponent("Error");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", {
        class: _normalizeClass([{
          'headerAndroid': _unref(env).isModianAndroid()
        }, {
          'is-scrolled': isScrolled.value
        }]),
        style: _normalizeStyle({
          'padding-top': _unref(state).statusBarH + 'px'
        })
      }, [(_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid()) && !_unref(state).is_ip ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: "back-icon",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter(isScrolled.value ? 'https://p6.moimg.net/mdwxapp/merchant/nav_back_black.png' : 'https://p6.moimg.net/mdwxapp/merchant/nav_back.png', 56),
        onClick: _withModifiers(handleGoBack, ["stop"])
      }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "rule-info",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleTaskRule(), ["stop"]))
      }, [_createVNode(_component_van_image, {
        class: "icon",
        src: _ctx.$imgUrlFilter(isScrolled.value ? 'https://p6.moimg.net/mdwxapp/merchant/nav_rule_black.png' : 'https://p6.moimg.net/mdwxapp/merchant/nav_rule.png', 28)
      }, null, 8, ["src"]), _hoisted_2]), _createElementVNode("div", {
        class: "share-info",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleShareAction(), ["stop"]))
      }, [_createVNode(_component_van_image, {
        class: "icon",
        src: _ctx.$imgUrlFilter(isScrolled.value ? 'https://p6.moimg.net/mdwxapp/merchant/nav_share_black.png' : 'https://p6.moimg.net/mdwxapp/merchant/nav_share.png', 28)
      }, null, 8, ["src"]), _hoisted_3])], 6), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(state).refreshing,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(state).refreshing = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          class: "list",
          loading: _unref(state).loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = $event => _unref(state).loading = $event),
          finished: !_unref(state).is_next,
          "immediate-check": false,
          onLoad: onLoadMore
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            class: "bg-img",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_rank_top_back.png', 750)
          }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
            class: "money-img-icon",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_rank_extra_icon.png', 370)
          }, null, 8, _hoisted_7)]), _unref(state).date_range.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(state).date_range) + "(实时更新) ", 1)) : _createCommentVNode("", true), _createVNode(_component_van_image, {
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_rank_history_icon.png', 180),
            class: "history",
            onClick: _withModifiers(handleHostoryAction, ["stop"])
          }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_9, [_unref(state).rankList.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_unref(state).user_rank_info && _unref(state).user_rank_info.user_id ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["list-card is_me", {
              'is_me_first': _unref(state).user_rank_info.rank == 1
            }])
          }, [_unref(state).user_rank_info.rank > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("img", {
            class: "me-img",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_rank_my_turn.png', 112)
          }, null, 8, _hoisted_10), _ctx.rank <= 3 ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            class: "index-icon",
            src: _ctx.$imgUrlFilter(`https://p6.moimg.net/mdwxapp/miner/miner_rank_0${_ctx.rank}.png`, 48)
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(state).user_rank_info.rank), 1))], 64)) : (_openBlock(), _createBlock(_component_van_image, {
            key: 1,
            class: "index-icon",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/miner/miner_none_rank.png', 48)
          }, null, 8, ["src"])), _createVNode(_component_van_image, {
            class: "icon",
            src: _ctx.$imgUrlFilter(_unref(state).user_rank_info.icon, 80)
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.nick_name) + " ", 1), _createElementVNode("div", {
            class: "des",
            style: _normalizeStyle(statusNameStyle(_unref(state).user_rank_info.medal_level))
          }, _toDisplayString(_unref(state).user_rank_info.medal), 5)]), _createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.prize) + " ", 1), _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(state).user_rank_info.prize_desc), 1)]), _createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(_unref(state).user_rank_info.score) + " ", 1), _hoisted_16]), _unref(state).user_rank_info.rank == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 站外宣发条件:目标达成且筹资≥10w ")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).rankList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "list-card",
              key: index
            }, [index < 3 ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "index-icon",
              src: _ctx.$imgUrlFilter(`https://p6.moimg.net/mdwxapp/miner/miner_rank_0${index + 1}.png`, 48)
            }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(index + 1), 1)), _createVNode(_component_van_image, {
              class: "icon",
              src: _ctx.$imgUrlFilter(item.icon, 80)
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_19, [_createTextVNode(_toDisplayString(item.nick_name) + " ", 1), _createElementVNode("div", {
              class: "des",
              style: _normalizeStyle(statusNameStyle(item.medal_level))
            }, _toDisplayString(item.medal), 5)]), _createElementVNode("div", _hoisted_20, [_createTextVNode(_toDisplayString(item.prize) + " ", 1), _createElementVNode("div", _hoisted_21, _toDisplayString(item.prize_desc), 1)]), _createElementVNode("div", _hoisted_22, [_createTextVNode(_toDisplayString(item.score) + " ", 1), _hoisted_23])]);
          }), 128))], 64)) : _unref(state).request_finished ? (_openBlock(), _createBlock(_component_Error, {
            key: 1,
            message: "什么都没有哦",
            class: "empty-box"
          })) : _createCommentVNode("", true)])])]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: "bottom-fixed"
      }, [_createElementVNode("div", {
        class: "task-action-btn",
        onClick: goToMinerTaskCenter
      }, " 赚挖矿分 ")])]), _createVNode(ShareBox)], 64);
    };
  }
};